// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".creative-row[data-v-2b965070]{background-color:#f5f6f7}.creative-thumbnail[data-v-2b965070]{width:35px;height:35px;overflow:hidden}.placeholder-thumb.tiny[data-v-2b965070]{width:35px;height:35px;background-color:#dee2e6;border-radius:4px}", ""]);
// Exports
module.exports = exports;
